<template>
    <div
        ref="container"
        style="display: flex; flex-direction: row; justify-content: start;">
        <template v-for="(icon, index) in vicons">
            <template v-if="(icon.show ? icon.show(value, item) : true)">
                <div
                    v-if="hovered"
                    class="vue-table-icon"
                    :class="{'show-always': alwaysShow || (!!icon.on && icon.on === 'visible')}"
                    :key="index">
                    <!-- v-dialog 아이콘 -->
                    <vue-data-table-icon-dialog
                        v-if="icon.isDialog"
                        :icon="icon"
                        :item="item"
                        :value="value"
                        :header="header"
                    >
                    </vue-data-table-icon-dialog>
                    <!-- v-menu 아이콘 -->
                    <vue-data-table-icon-menu
                        v-else-if="icon.isMenu"
                        :icon="icon"
                        :item="item"
                        :value="value"
                        :header="header"
                    >
                    </vue-data-table-icon-menu>
                    <!-- callback 이 있는 아이콘 -->
                    <vue-data-table-icon
                        v-else-if="icon.callback"
                        :icon="icon"
                        :item="item"
                        :value="value"
                        :header="header"
                    >
                    </vue-data-table-icon>
                    <!-- tooltip -->
                    <vue-data-table-icon-tooltip
                        v-else
                        :icon="icon"
                        :item="item"
                        :value="value"
                        :header="header"
                    >
                    </vue-data-table-icon-tooltip>
                </div>
                <!-- 여백 유지 -->
                <div v-else :key="index" :style="{width: vicons.length * 24 + 'px'}">
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import VueDataTableIcon from "@/assets/plugins/vue-data-table/components/VueDataTableIcon";
import VueDataTableIconTooltip from "@/assets/plugins/vue-data-table/components/VueDataTableIconTooltip";
import VueDataTableIconDialog from "@/assets/plugins/vue-data-table/components/VueDataTableIconDialog";
import VueDataTableIconMenu from "@/assets/plugins/vue-data-table/components/VueDataTableIconMenu";

export default {
    name: "VueDataTableIcons",
    components: {VueDataTableIconMenu, VueDataTableIconDialog, VueDataTableIconTooltip, VueDataTableIcon},
    props: {
        vicons: {
            type: Array,
            default: () => [],
        },
        item: {
            type: Object,
            default: () => {},
        },
        header: {
            type: Object,
            default: () => {},
        },
        alwaysShow: {
            type: Boolean,
            default: false,
        },
        value: undefined,
    },
    data() {
        return {
            hovered: false,
            // delay: false,
        };
    },
    created() {
        // setTimeout(() => {
        //     this.delay = true;
        // }, 3000);
    },
    mounted() {
        const td = this.$refs.container.closest("tr");
        if (td) td.onmouseenter = e => this.hovered = true;
        if (td) td.onmouseleave = e => this.hovered = false;
    },
}
</script>

<style scoped>
/* vue table icon 의 기본 속성 정의 */
.vue-table-icon {
    visibility: hidden;
    width: 24px;
    height: 24px;
}

tr:hover .vue-table-icon {
    visibility: visible;
}

.vue-table-icon.show-always {
    visibility: visible !important;
}

>>> a.icon--button {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

>>> a.icon--button:not(.disabled):hover {
    background-color: #ddd;
    border-radius: 50%;
}
/* vue table icon 의 기본 속성 정의 끝 */
</style>